'use strict';

var React = require('react');

var SvgBugIcon = function SvgBugIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.28 3.97a.75.75 0 0 1 0 1.06l-.793.794c.4.475.667 1.067.742 1.717.349.073.663.241.914.477l1.157-.868a.75.75 0 1 1 .9 1.2l-1.45 1.088v1.312h1.5a.75.75 0 0 1 0 1.5h-1.605a4.717 4.717 0 0 1-.33.987l1.885 1.413a.75.75 0 1 1-.9 1.2l-1.821-1.366a4.737 4.737 0 0 1-3.479 1.516 4.737 4.737 0 0 1-3.479-1.516l-1.821 1.366a.75.75 0 1 1-.9-1.2l1.884-1.413a4.712 4.712 0 0 1-.329-.987h-1.605a.75.75 0 0 1 0-1.5h1.5v-1.313l-1.45-1.087a.75.75 0 1 1 .9-1.2l1.157.868c.25-.236.565-.404.914-.477a3.24 3.24 0 0 1 .742-1.717l-.793-.794a.75.75 0 0 1 1.06-1.06l.953.953a3.24 3.24 0 0 1 1.267-.256c.45 0 .877.09 1.267.256l.953-.953a.75.75 0 0 1 1.06 0Zm-6.53 6.78v.5a3.251 3.251 0 0 0 2.5 3.163v-5.413h-2.083a.417.417 0 0 0-.417.417v1.333Zm6.5-1.333v1.833a3.251 3.251 0 0 1-2.5 3.163v-5.413h2.083c.23 0 .417.187.417.417Zm-3.25-3.25a1.75 1.75 0 0 1 1.7 1.333h-3.4a1.75 1.75 0 0 1 1.7-1.333Z"
  }));
};
SvgBugIcon.displayName = "BugIcon";

exports.SvgBugIcon = SvgBugIcon;
